import { Component, Input } from '@angular/core';
import { SvcBtnIconBaseComponent } from '@solvace/component/svc-btn-icon';

@Component({ template: '' })
export class SvcButtonIconCustomBaseComponent extends SvcBtnIconBaseComponent {
  @Input() buttonId: string;

  protected onClick(event: MouseEvent): void {
    super.onClick(event);
    if (!this.disabled && !this.processing) {
      this.autoFocus = true;
    }
  }
}
